import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-4"
}
const _hoisted_3 = { class: "text-xs" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = {
  key: 3,
  class: "ml-auto flex items-center justify-center text-xs font-medium"
}

import { type Table } from '@tanstack/vue-table';
    import { computed } from 'vue';
    import {
        Select,
        SelectContent,
        SelectItem,
        SelectTrigger,
        SelectValue,
    } from '@/components/ui/select';
    import { Separator } from '@/components/ui/separator';
    import { AcceptableValue } from 'reka-ui';
    import DataTablePagination from '@/components/datatable/DataTablePagination.vue';

    interface DataTableOptionsProps {
        table: Table<any>;
        hideControls?: boolean;
        manualPagination?: boolean;
        totalRecords?: number;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableOptions',
  props: {
    table: {},
    hideControls: { type: Boolean, default: false },
    manualPagination: { type: Boolean, default: false },
    totalRecords: { default: undefined }
  },
  setup(__props: any) {

    const props = __props;

    const totalRows = computed(() => {
        if (props.manualPagination && props.totalRecords !== undefined) {
            return props.totalRecords;
        }
        return props.table.getFilteredRowModel().flatRows.filter((row) => !row.subRows?.length)
            .length;
    });

    const selectedRows = computed(() => {
        return props.table.getFilteredSelectedRowModel().flatRows.length;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!!selectedRows.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(selectedRows.value), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('datatables.of')) + " ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(totalRows.value), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('datatables.rows_selected')), 1)
          ]),
          _createVNode(_unref(Separator), {
            orientation: "vertical",
            class: "h-2.5!"
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hideControls)
      ? (_openBlock(), _createBlock(_unref(Select), {
          key: 1,
          "model-value": _ctx.table.getState().pagination.pageSize,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.table.setPageSize(Number(value)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SelectTrigger), { class: "h-8 cursor-pointer gap-1 border-none px-0 shadow-none" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('datatables.show')) + " ", 1),
                _createVNode(_unref(SelectValue), {
                  placeholder: _ctx.table.getState().pagination.pageSize.toString(),
                  class: "font-bold"
                }, null, 8, ["placeholder"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('datatables.rows')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(SelectContent), { side: "top" }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([10, 20, 40, 60, 80, 100], (pageSize) => {
                  return _createVNode(_unref(SelectItem), {
                    key: pageSize,
                    value: pageSize
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(pageSize), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"])
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model-value"]))
      : _createCommentVNode("", true),
    (!_ctx.hideControls)
      ? (_openBlock(), _createBlock(_unref(Separator), {
          key: 2,
          orientation: "vertical",
          class: "h-2.5!"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, _toDisplayString(totalRows.value), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('datatables.entries')), 1)
    ]),
    (!_ctx.hideControls)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('datatables.page')) + " " + _toDisplayString(_ctx.table.getState().pagination.pageIndex + 1) + " " + _toDisplayString(_ctx.$t('datatables.of')) + " " + _toDisplayString(_ctx.table.getPageCount()), 1))
      : _createCommentVNode("", true),
    (!_ctx.hideControls)
      ? (_openBlock(), _createBlock(_unref(Separator), {
          key: 4,
          orientation: "vertical",
          class: "h-2.5!"
        }))
      : _createCommentVNode("", true),
    (!_ctx.hideControls)
      ? (_openBlock(), _createBlock(DataTablePagination, {
          key: 5,
          table: _ctx.table,
          "total-records": totalRows.value
        }, null, 8, ["table", "total-records"]))
      : _createCommentVNode("", true)
  ]))
}
}

})